import { render, staticRenderFns } from "./AddFiledBtn.vue?vue&type=template&id=b372556e&"
import script from "./AddFiledBtn.vue?vue&type=script&lang=js&"
export * from "./AddFiledBtn.vue?vue&type=script&lang=js&"
import style0 from "./AddFiledBtn.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports